import {MAILING} from './mailingActionTypes';

export function setEditMailingData(data) {
  return {
    type: MAILING.SET_MAILING_POPUP_DATA,
    payload: {
      data: data.data,
      isView: data.isView
    }
  };
}

export function clearEditMailingData(isView) {
  return {
    type: MAILING.SET_MAILING_POPUP_DATA,
    payload: {
      data: {},
      isView: isView
    }
  };
}

export function addMailing(data) {
  return {
    type: MAILING.ADD_MAILING,
    payload: {
      client: 'default',
      request: {
        url: `companies/mails`,
        method: 'post',
        data
      }
    }
  };
}

export function editMailing(data, id) {
  return {
    type: MAILING.EDIT_MAILING,
    payload: {
      client: 'default',
      request: {
        url: `companies/mails/${id}`,
        method: 'post',
        data
      }
    }
  };
}

export function getMailings() {
  return {
    type: MAILING.GET_MAILINGS,
    payload: {
      client: 'default',
      request: {
        url: `companies/mails`,
        method: 'get'
      }
    }
  };
}
